<template>
  <b-card no-body class="mb-0">
    <!-- chart -->
    <b-card-body class="pb-0 px-0">
      <chartjs-component-horizontal-bar-chart
        ref="charts"
        :height="computedHeight"
        :data="localData"
        :options="chartjsDataCopy"
        v-if="loadChart"
      />
      <b-card :style="{ height: heightChart + 'px' }" v-else>
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </b-card>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody
} from 'bootstrap-vue';
import ChartjsComponentHorizontalBarChart from '@components/charts-components/ChartjsComponentHorizontalBarChart.vue';
import chartjsData from '@/components/charts-components/chartjsData';

export default {
  components: {
    BCard,
    BCardBody,

    ChartjsComponentHorizontalBarChart,
  },
  props: {
    inf_id: {
      type: Number,
    },
    chartData: {
      type: Object,
      default: () => ({}), // Varsayılan boş obje
    },
    loadChart: {
      type: Boolean,
      default: () => true,
    },
    totalAmount: {
      type: [String, Number], // Hem String hem Number kabul eder
    },
    heightChart: {
      type: Number, // Hem sayı hem de string olabilir
    },
    hasParcent:{
      type: Boolean,
      default: () => true,
    }
  },
  data() {
    return {
      chartjsData,
      chartjsDataCopy: {}, // options kopyası
      localData: {}, // Grafik verisix
    };
  },
  methods: {
    updateChartOptions() {

      if (this.chartjsDataCopy.scales) {
        const stepBase = 50; // Yuvarlama için temel değer
        const maxTicks = 15; // Maksimum 15 değer görünsün

        const stepSize = Math.ceil((this.maxTickValue / maxTicks) / stepBase) * stepBase;

        this.chartjsDataCopy.scales.xAxes[0].ticks = {
          stepSize: stepSize,
          min: 0,
          fontColor: '#6e6b7b',
          fontSize: 11,
          callback: function (value) {
            return `${value} TL`; // Değere "TL" ekleniyor
          },
        };

      }
      if (this.localData.labels) {
        this.localData.labels = this.localData.labels.map((label, index) => {
          const value = this.localData.datasets[0].data[index]; // Veri değeri

          // Yüzde hesaplama güvenli hale getirildi
          let percentage = 0;
          if (this.totalAmount && this.totalAmount !== 0) {
            percentage = (value[1] / this.totalAmount * 100).toFixed(2);
          }

          if (this.hasParcent) {
            return `${label} - %${percentage}`;
          } else {
            return `${label}`;
          }
        });
      }
    },
    handleBarClick(event, elements) {
        const elementIndex = elements[0]._index;
        // Veriyi yukarı iletme (isteğe bağlı)
        this.$emit('select-row', elementIndex);
    }
  },
  computed: {
    maxTickValue() {
      if (this.localData.datasets && this.localData.datasets[0].data.length > 0) {
        const maxDataValue = Math.max(...this.localData.datasets[0].data);
        return Math.ceil(maxDataValue * 1.5);
      }
      return 40;
    },
    computedHeight() {
      return this.heightChart || ((this.chartData?.labels?.length || 1) * 30 + 100);
    }

  },
  mounted() {
    this.chartjsDataCopy = JSON.parse(JSON.stringify(this.chartjsData.horizontalBarChart.options));

    const _self = this;
    this.chartjsDataCopy.tooltips.callbacks = {
      label(tooltipItem) {
        const valueArray = JSON.parse(tooltipItem.value);
        return `${valueArray[0]} Adet /  ${_self.priceFormat(valueArray[1])}`;
      }
    };
    
    this.chartjsDataCopy.onClick= (event, elements) => this.handleBarClick(event, elements)
  },
  watch: {
    chartData: {
      handler(newData) {
        this.localData = newData;
        this.updateChartOptions();
      },
    },
  },
};
</script>
<style>
canvas {
  text-align: left;
}
</style>